import React, { useState } from "react";
import { toast } from "react-toastify";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { FileUploader } from "react-drag-drop-files";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import {
  validateIncomeProof,
  uploadAddressProofApi,
} from "designs/v1/pages/ModifyKyc/services";
import { jsonToFormData } from "utils";
import { handleFileResizer } from "utils/imageResizer";

const AddressProofModification = ({
  activeUserDetail,
  stageScreen,
  setStageScreen,
  setStep,
  isLoading,
  setIsLoading,
}) => {
  const addressTypes = [
    { name: "None", value: "" },
    { name: "Aadhaar", value: "Aadhaar" },
    { name: "Voter ID", value: "VoterID" },
    { name: "Passport", value: "Passport" },
    { name: "Driving License", value: "DrivingLicense" },
  ];
  const initialValues = {
    type: "",
    file1: "",
    file2: "",
    file_type: "Image",
  };
  // const validationSchema = Yup.object().shape({
  //   type: Yup.string().required(),
  //   file1: Yup.string().required(),
  // });
  const handleValidate = (values) => {
    const errors = {};
    if (!values.type || !values.file1) {
      errors.type = "Required";
    }
    if (!["DrivingLicense"].includes(values.type) && !values.file2) {
      errors.file2 = "Required";
    }
    return errors;
  };
  const handleSubmit = async (value, { resetForm }) => {
    setIsLoading(true);
    const formValue = {
      ...value,
      document_name: localStorage.getItem("AddressRequestNumber"),
      existing_customer: activeUserDetail.existing_customer,
    };
    const payload = jsonToFormData(formValue);
    try {
      const resp = await uploadAddressProofApi(payload);
      console.log("resp", resp);
      setIsLoading(false);
      // if (resp.data.message?.status_code !== 200) {
      //   return toast.error(resp.data.message?.message);
      // }
      toast.success(resp.data.message?.message, "Success");
      if (
        localStorage.getItem("AddressRequestType") ===
        "Permanent Address Modification"
      ) {
        setStep("PermanentAddressForm");
      } else {
        setStep("AddressInfoModification");
      }
    } catch (error) {
      const { data } = error.response || {};
      toast.error(data.message || "Internal server error!");
      setIsLoading(false);
    }
  };
  const handleFileUpload = async (name, file, setFieldValue) => {
    if (!file) {
      return setFieldValue(name, "");
    }
    const allowed_types = ["image/png", "image/jpeg", "application/pdf"];
    if (!allowed_types.includes(file.type)) {
      setFieldValue(name, "");
      return toast.error(
        "Only Images/Pdf are allowed ( JPG | PNG | PDF )",
        "Error"
      );
    }
    const fileSize = file.size / 1024 ** 2;
    if (fileSize >= 4) {
      setFieldValue(name, "");
      return toast.error("Error: Please upload a file smaller than 4 MB");
    }
    if (file.type === "application/pdf") {
      setFieldValue("file_type", "pdf");
      setIsLoading(true);
      try {
        const resp = await validateIncomeProof(jsonToFormData({ file }));
        const isEncrypted = resp.data?.message;
        if (isEncrypted) {
          setFieldValue(name, "");
          toast.error("Please upload a file without password protected.");
        } else {
          setFieldValue(name, file);
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        setFieldValue(name, "");
        toast.error("Internal server error!");
      }
    } else {
      setFieldValue("file_type", "Image");
      const img = new Image();
      img.src = window.URL.createObjectURL(file);
      img.onload = async () => {
        if (img.width >= 400 && img.height >= 350) {
          const newFile = await handleFileResizer(file);
          setFieldValue(name, newFile);
        } else {
          setFieldValue(name, "");
          return toast.error(
            `The image you uploaded is of lower resolution. Please upload a higher resolution image.`
          );
        }
      };
    }
  };
  return (
    <React.Fragment>
      <Title title="Upload your address proof" />
      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <div className="mb-2">
              <Formik
                initialValues={initialValues}
                validate={handleValidate}
                onSubmit={handleSubmit}
              >
                {({ values, isValid, dirty, isSubmitting, setFieldValue }) => (
                  <Form>
                    <div className="form-group my-2">
                      <label className="py-1">Address Type</label>
                      <Field
                        as="select"
                        name="type"
                        className="form-select"
                      >
                        {addressTypes.map((option, index) => {
                          return (
                            <option
                              key={index}
                              value={option.value}
                            >
                              {option.name}
                            </option>
                          );
                        })}
                      </Field>
                    </div>
                    <div className="form-group my-2">
                      <div className="d-flex align-items-center justify-content-between">
                        <label className="py-1">Front Image</label>
                        <div className="file_limit_text">
                          Maximum file size: 4 MB
                        </div>
                      </div>
                      <Field name="file1">
                        {(props) => (
                          <div className="file-uploader-container">
                            <FileUploader
                              {...props}
                              handleChange={(file) =>
                                handleFileUpload("file1", file, setFieldValue)
                              }
                              name="file"
                              types={["JPG", "JPEG", "PNG", "PDF"]}
                            />
                            {/* <div className="d-flex mx-2 my-1">
                                <svg
                                  width="32"
                                  height="32"
                                  viewBox="0 0 32 32"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M5.33317 6.66667H22.6665V16H25.3332V6.66667C25.3332 5.196 24.1372 4 22.6665 4H5.33317C3.8625 4 2.6665 5.196 2.6665 6.66667V22.6667C2.6665 24.1373 3.8625 25.3333 5.33317 25.3333H15.9998V22.6667H5.33317V6.66667Z"
                                    fill="#0658C2"
                                  ></path>
                                  <path
                                    d="M10.6665 14.6667L6.6665 20H21.3332L15.9998 12L11.9998 17.3333L10.6665 14.6667Z"
                                    fill="#0658C2"
                                  ></path>
                                  <path
                                    d="M25.3332 18.6667H22.6665V22.6667H18.6665V25.3333H22.6665V29.3333H25.3332V25.3333H29.3332V22.6667H25.3332V18.6667Z"
                                    fill="#0658C2"
                                  ></path>
                                </svg>
                                {values.file1 ? (
                                  <div className="d-flex">
                                    <span className="">
                                      <span>Uploaded Successfully!</span> Upload another?
                                    </span>
                                  </div>
                                ) : (
                                  <div
                                    className="d-flex align-items-center justify-content-between"
                                    style={{ width: "90%" }}
                                  >
                                    <span>
                                      <span>Upload</span> or drop a file right here
                                    </span>
                                    <span>JPG, PNG, PDF</span>
                                  </div>
                                )}
                              </div> */}
                          </div>
                        )}
                      </Field>
                      {values?.file1 && (
                        <p>
                          <small>File name: {values.file1?.name}</small>
                        </p>
                      )}
                    </div>
                    <div className="form-group my-2">
                      <div className="d-flex align-items-center justify-content-between">
                        <label className="py-1">Back Image</label>
                        <div className="file_limit_text">
                          Maximum file size: 4 MB
                        </div>
                      </div>
                      <Field name="file2">
                        {(props) => (
                          <div className="file-uploader-container">
                            <FileUploader
                              {...props}
                              handleChange={(file) =>
                                handleFileUpload("file2", file, setFieldValue)
                              }
                              name="file"
                              types={["JPG", "JPEG", "PNG", "PDF"]}
                            />
                          </div>
                        )}
                      </Field>
                      {values?.file2 && (
                        <p>
                          <small>File name: {values.file2?.name}</small>
                        </p>
                      )}
                    </div>
                    {/* <div className="form-group my-2">
                          <label>Document name</label>
                          <Field
                            type="text"
                            name="document_name"
                            placeholder=""
                            className="form-control"
                          />
                        </div> */}
                    <div className="d-flex my-4">
                      <div className="mx-1">
                        <Button
                          type="button"
                          title="Back"
                          handleClick={() => setStep("DematUccForm")}
                          disabled={isLoading}
                        />
                      </div>
                      <div className="mx-1">
                        <Button
                          title="Submit"
                          disabled={!isValid || !dirty || isSubmitting}
                        />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AddressProofModification;
